import { NgModule } from "@angular/core";
import { QuizComponent } from "./quiz.component";
import { RouterModule, Routes } from "@angular/router";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { CoreCommonModule } from "@core/common.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { AuthGuard } from "@core/helpers";
import { Role } from "@core/models";
import { QuizPageComponent } from "./components/quiz-page/quiz-page.component";
import { LearnService } from "../learn/learn-module.service";
import { SharedModule } from "app/shared/shared.module";
import { LeaderboardsComponent } from './components/leaderboards/leaderboards.component';
import { LeaderboardInfoPageComponent } from './components/leaderboard-info-page/leaderboard-info-page.component';
import { GiftsComponent } from './components/gifts/gifts.component';
import { GiftsListComponent } from './components/gifts-list/gifts-list.component';
import { FinishQuizModalComponent } from './finish-quiz-modal/finish-quiz-modal.component';
import { AnswerCheckModalComponent } from './components/answer-check-modal/answer-check-modal.component';
import { QuizLeaderboardMoveComponent } from './components/quiz-leaderboard-move/quiz-leaderboard-move.component';

const routes: Routes = [
  {
    path: ":topicId/subject/:subjectId/form/:formNumber",
    component: QuizComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.Student,
        Role.independentStudent,
        Role.Teacher,
        Role.Admin,
        Role.SuperAdmin,
      ],
      animation: "quiz",
      level: "topic",
    },
  },
  {
    path: "subject/:subjectId/form/:formNumber",
    component: QuizComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.Student,
        Role.independentStudent,
        Role.Teacher,
        Role.Admin,
        Role.SuperAdmin,
      ],
      animation: "formquiz",
      level: "form",
    },
  },
  {
    path: "lesson/:lessonId/subject/:subjectId/form/:formNumber",
    component: QuizComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.Student,
        Role.independentStudent,
        Role.Teacher,
        Role.Admin,
        Role.SuperAdmin,
      ],
      animation: "quiz",
      level: "lesson",
    },
  },
  {
    path: "normal-quiz",
    component: QuizPageComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.Student,
        Role.independentStudent,
        Role.Teacher,
        Role.Admin,
        Role.SuperAdmin,
      ],
    },
  },
  {
    path: "normal-quiz/:id",
    component: QuizPageComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.Student,
        Role.independentStudent,
        Role.Teacher,
        Role.Admin,
        Role.SuperAdmin,
      ],
    },
  },
  {
    path: "leaderboard",
    component: LeaderboardsComponent,
    canActivate: [AuthGuard ]
  },
  {
    path: "leaderboard-move",
    component: QuizLeaderboardMoveComponent,
    canActivate: [AuthGuard ]
  },
  {
    path: "gifts",
    component: GiftsListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Role.Student,
        Role.independentStudent
      ]
    }
  },
  {
    path: "siyavula",
    loadChildren: () =>
      import("./siyavula/siyavula.module").then((m) => m.SiyavulaModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [QuizComponent, QuizPageComponent, LeaderboardsComponent, LeaderboardInfoPageComponent, GiftsComponent, GiftsListComponent, FinishQuizModalComponent, AnswerCheckModalComponent, QuizLeaderboardMoveComponent],
  imports: [
    RouterModule.forChild(routes),
    CoreCommonModule,
    ContentHeaderModule,
    NgxDatatableModule,
    NgbModule,
    SweetAlert2Module.forRoot(),
    SharedModule,
  ],
  exports: [GiftsComponent],
  providers: [LearnService],
})
export class QuizModule {}
